var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V15L8 21L16 15V4C16 1.79086 14.2091 0 12 0H4Z",
    fill: "#181D1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.61f88cb8f7f7d2781f99776cf306f519.svg";
export { ForwardRef as ReactComponent };